import React, { Profiler, useEffect, useState } from "react";
import {
    FaSignOutAlt,
    FaQuestionCircle,
    FaHistory,
    FaClipboardCheck,
    FaGraduationCap,
    FaStar,
    FaFire,
    FaTrophy,
    FaBell,
    FaChartLine,
    FaChartBar,
    FaUsers,
    FaLaptopCode,
    FaBookOpen
} from "react-icons/fa";
import {
    Atom,
    TestTube,
    Leaf,
    Calculator,
    Sprout,
    TrendingUp,
    Cross,
    PenTool,
    Book,
    Microscope,
    Monitor,
    Globe,
    Users as UsersIcon,
    Heart,
    Briefcase,
    Palette,
    Home,
    Shield,
    BookOpen,
    FileText,
    BarChart3,
    Building2,
    Coffee,
    Activity,
    Target,
    Gamepad2,
    Zap,
    Plus,
    TreePine,
    ChevronDown,
    ChevronUp,
    Settings,
    Brain,
    Clock,
    Calendar,
    Play,
    FunctionSquare,
    User,
    User2,
    Star,
    Wrench
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import WOW from "wowjs";
import "animate.css";
import { API_BASE_URL } from "../../config/apiConfig";
import toast, { Toaster } from "react-hot-toast";

const FreeDashboard = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [showAllSubjects, setShowAllSubjects] = useState(false);
    const [currentTime, setCurrentTime] = useState(new Date());

    const token = localStorage.getItem("token");

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []); // runs only on mount


    useEffect(() => {
        const fetchExams = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/tests-free/analysis`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("token")}`
                    },
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || "Failed to fetch exam data");
                }

                const exams = await response.json();
                console.log(exams.data);

                const cutoffDate = new Date(); // set your desired cutoff
                // const stats = calculateStudyStats(exams.data, cutoffDate);
                // const recent = getRecentActivity(exams.data, 4);
                // setRecentActivity(recent);


            } catch (error) {
                console.error("Error fetching exam data:", error.message);
            }
        };

        fetchExams();
    }, []);







    const quickActions = [
        // Core Learning & Practice
        {
            id: 1,
            title: "Study Mode",
            description: "Learn concepts at your own pace",
            icon: <FaBookOpen color="#2148C0" />,
            path: "/free-take/study",
            color: "from-blue-500 to-sky-600", // deep to bright blue
        },
        {
            id: 2,
            title: "Exam Mode",
            description: "Simulate real exam conditions",
            icon: <FaLaptopCode color="#2148C0" />,
            path: "/choose-exam-free",
            color: "from-red-500 to-orange-600", // bold red-orange
        },

        // Community First
        // {
        //     id: 5,
        //     title: "Exam Performance",
        //     description: "View detailed performance per exam",
        //     icon: <FaChartBar color="#2148C0" />,
        //     path: "/exam-performance",
        //     color: "from-purple-500 to-fuchsia-600", // vivid purple-pink
        // },

        // Performance & Tracking
        {
            id: 7,
            title: "Exam History",
            description: "Review your past exam attempts",
            icon: <FaHistory color="#2148C0" />,
            path: "/exam-history-free",
            color: "from-indigo-500 to-violet-600", // royal indigo gradient
        },

        // Support tool (last)
        {
            id: 8,
            title: "Search Questions",
            description: "Find questions and explanations",
            icon: <FaQuestionCircle color="#2148C0" />,
            path: "/search-questions",
            color: "from-rose-500 to-pink-600", // cheerful rose-pink
            requiresSubscription: true,
        },
    ];


    const timeAgo = (dateString) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffSeconds = Math.floor((now - date) / 1000);

        if (diffSeconds < 60) return `${diffSeconds} seconds ago`;
        if (diffSeconds < 3600) return `${Math.floor(diffSeconds / 60)} minutes ago`;
        if (diffSeconds < 86400) return `${Math.floor(diffSeconds / 3600)} hours ago`;
        return `${Math.floor(diffSeconds / 86400)} days ago`;
    };

    const subjectIcons = {
        "Physics": Atom,
        "Chemistry": TestTube,
        "Biology": Leaf,
        "Further Mathematics": FunctionSquare,
        "Mathematics": Calculator,
        "Agricultural Science": Sprout,
        "Commerce": TrendingUp,
        "CRS": Cross,
        "Christian Religious Studies (CRS)": Cross,
        "English Language": PenTool,
        "English Studies": Book,
        "Basic Science": Microscope,
        "Basic Technology": Monitor,
        "Social Studies": Globe,
        "Civic Education": UsersIcon,
        "Computer Science": Monitor,
        "Physical and Health Education": Heart,
        "Physical and Health Education (PHE)": Heart,
        "Business Studies": Briefcase,
        "Creative Arts": Palette,
        "Home Economics": Home,
        "Security Education": Shield,
        "Literature": BookOpen,
        "Geography": Globe,
        "History": FileText,
        "Economics": BarChart3,
        "Government": Building2,
        "French": Coffee,
        "Arabic": Book,
        "Hausa": Book,
        "Igbo": Book,
        "Yoruba": Book,
        "Fine Arts": Palette,
        "Music": Activity,
        "Technical Drawing": Target,
        "Auto Mechanics": Gamepad2,
        "Electronics": Zap,
        "Building Construction": Building2,
        "Metal Work": Plus,
        "Wood Work": TreePine,
        "Food and Nutrition": Home,
        "Clothing and Textiles": Home
    };



    useEffect(() => {
        new WOW.WOW({
            live: true,
            boxClass: "wow",
            animateClass: "animate__animated",
            offset: 0,
            mobile: true,
            duration: 2,
        }).init();
    }, []);

    // Fetch user profile
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/free-users/profile`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("token")}`
                    },
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || "Failed to fetch user profile");
                }

                const userData = await response.json();
                console.log(userData);

                // Map only existing fields from FreeUser model
                const filteredData = {
                    id: userData.id || "",
                    name: userData.name || "",
                    email: userData.email || "",
                    yearGroup: userData.yearGroup || "",
                    subjects: userData.subjects || [],
                    createdAt: userData.createdAt || "",
                    updatedAt: userData.updatedAt || "",
                    accountType: "free",
                    isFreeUser: true
                };

                setUserData(filteredData);

            } catch (error) {
                console.error("Error fetching user profile:", error.message);
            }
        };

        fetchProfile();
    }, []);


    // Parse subjects from string
    const userSubjects = (() => {
        try {
            // 1. Check if the property exists
            const rawSubjects = userData?.subjects;

            // 2. If it's already an array, return it. 
            // If it's a string, parse it.
            return typeof rawSubjects === 'string'
                ? JSON.parse(rawSubjects)
                : (rawSubjects || []);
        } catch (error) {
            // 3. Fallback to empty array if parsing fails
            console.error("Failed to parse subjects:", error);
            return [];
        }
    })();

    const displayedSubjects = showAllSubjects ? userSubjects : userSubjects.slice(0, 6);

    // Get icon component for a subject
    const getSubjectIcon = (subject) => {
        const IconComponent = subjectIcons[subject] || Book;
        return <IconComponent className="w-6 h-6 text-[#2148C0]" />;
    };

    // const recentActivity = [
    //     { subject: "Mathematics", score: 85, date: "2 hours ago", type: "practice" },
    //     { subject: "Physics", score: 92, date: "1 day ago", type: "exam" },
    //     { subject: "Chemistry", score: 78, date: "2 days ago", type: "practice" }
    // ];

    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return "Good morning";
        if (hour < 17) return "Good afternoon";
        return "Good evening";
    };


    const handleNavigate = (path, comingSoon, requiresSubscription = false) => {
        if (!path || comingSoon) return; // do nothing
        if (requiresSubscription) {
            // show alert or toast
            toast.error("You need an active subscription to access this feature.");
            return;
        }
        navigate(path);
    };


    const handleLogout = async () => {
        try {
            const token = localStorage.getItem("token");
            const sessionStart = localStorage.getItem("sessionStart");
            const sessionEnd = new Date().toISOString(); // capture logout time

            if (token && sessionStart) {
                // Send session start and end to backend to update session duration
                await fetch(`${API_BASE_URL}/api/users/update-hours`, {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ sessionStart, sessionEnd }),
                });
            }
        } catch (error) {
            console.error("Error updating user stats:", error);
        } finally {
            window.location.href = "/free-login";
        }
    };
    console.log(userSubjects)


    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
            {/* Header */}
            <Toaster position="top-right" richColors />

            <header className="sticky top-0 z-50 backdrop-blur-md bg-white/80 border-b border-white/20 shadow-sm">
                <div className="container mx-auto px-4 py-4">
                    <div className="flex items-center justify-between">

                        {/* Left: Logo + Live + Timer */}
                        <div className="flex items-center space-x-6">
                            <h1 className="text-3xl font-bold bg-gradient-to-r from-[#2148C0] to-blue-600 bg-clip-text text-transparent flex items-center">
                                <FaGraduationCap className="mr-3 text-[#2148C0]" />
                                TeeChaa
                            </h1>

                            <div className="hidden md:flex items-center space-x-2 bg-blue-50 px-3 py-1 rounded-full">
                                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                                <span className="text-sm text-blue-700 font-medium">Live</span>
                            </div>
                        </div>

                        {/* Right: Notifications + Profile + Logout */}
                        <div className="flex items-center space-x-3">
                            <div className="flex items-center space-x-3 bg-white rounded-full p-1 shadow-sm border">
                                <button
                                    onClick={handleLogout}
                                    className="text-gray-600 hover:text-red-500 p-2 rounded-full hover:bg-red-50 transition-all duration-200"
                                >
                                    <FaSignOutAlt />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {/* <SubscriptionStatus /> */}
            <main className="container mx-auto px-4 py-8 max-w-7xl">
                {/* Welcome Section */}
                <div className="mb-8">
                    <div className="bg-gradient-to-r from-[#2148C0] to-blue-600 rounded-2xl p-6 md:p-8 text-white relative overflow-hidden">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16"></div>
                        <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full -ml-12 -mb-12"></div>

                        <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between">
                            <div>
                                <h2 className="text-2xl md:text-4xl font-bold mb-2">
                                    {getGreeting()}
                                    <span className="inline-block ml-2 animate-bounce">👋</span>
                                </h2>
                                <p className="text-blue-100 mb-4 md:mb-0 text-lg">
                                    Ready to achieve greatness today? Let's make it count!
                                </p>
                                <div className="flex items-center space-x-4 text-sm text-blue-200 mt-2">
                                    <span className="flex items-center">
                                        <Clock className="w-4 h-4 mr-1" />
                                        {currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                    </span>
                                    <span className="flex items-center">
                                        <Calendar className="w-4 h-4 mr-1" />
                                        {currentTime.toLocaleDateString()}
                                    </span>
                                </div>
                            </div>

                            <div className="flex space-x-4 mt-4 md:mt-0">
                                <button
                                    onClick={() => handleNavigate('/free-take/exam')}
                                    className="bg-white text-[#2148C0] px-6 py-3 rounded-xl font-semibold hover:bg-blue-50 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                                >
                                    <Play className="w-4 h-4 inline mr-2" />
                                    Start Exam
                                </button>
                                <button
                                    onClick={() => handleNavigate('/free-take/study')}
                                    className="border-2 border-white text-white px-6 py-3 rounded-xl font-semibold hover:bg-white hover:text-[#2148C0] transition-all duration-200"
                                >
                                    Practice
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Quick Actions */}
                <div className="mb-12">
                    {/* <h3 className="text-2xl font-bold text-gray-800 mb-8 flex items-center">
                        <Zap className="mr-3 w-7 h-7 text-[#2148C0]" />
                        Quick Actions
                    </h3> */}
                    <div className="space-y-8">
                        {/* Main Actions */}
                        <div>
                            <div className="flex items-center gap-2 mb-4">
                                <Star className="w-5 h-5 text-yellow-500" />
                                <h3 className="font-bold text-gray-800 text-lg">Core Actions</h3>
                            </div>

                            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-4 gap-6">
                                {quickActions.slice(0, 4).map((action) => (
                                    <div
                                        key={action.id}
                                        onClick={() => handleNavigate(action.path, action.comingSoon, action.requiresSubscription)}
                                        className={`group relative bg-white p-6 rounded-2xl shadow-md transition-all duration-300 border border-gray-100 overflow-hidden
                ${action.comingSoon
                                                ? "opacity-60 cursor-not-allowed"
                                                : "cursor-pointer hover:shadow-lg hover:-translate-y-2"
                                            }`}
                                    >
                                        {/* Hover overlay */}
                                        {!action.comingSoon && (
                                            <div
                                                className={`absolute inset-0 bg-gradient-to-r ${action.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}
                                            ></div>
                                        )}

                                        <div className="relative z-10 flex flex-col items-center text-center space-y-3">
                                            <div
                                                className={`text-4xl transition-transform duration-300 ${action.comingSoon
                                                    ? "opacity-70"
                                                    : "group-hover:scale-110"
                                                    }`}
                                            >
                                                {action.icon}
                                            </div>
                                            <h4
                                                className={`font-semibold text-gray-800 transition-colors duration-200 ${action.comingSoon
                                                    ? ""
                                                    : "group-hover:text-[#2148C0]"
                                                    }`}
                                            >
                                                {action.title}
                                            </h4>
                                            <p
                                                className={`text-sm text-gray-600 leading-snug transition-colors duration-200 ${action.comingSoon
                                                    ? ""
                                                    : "group-hover:text-gray-700"
                                                    }`}
                                            >
                                                {action.description}
                                            </p>

                                            {action.comingSoon && (
                                                <span className="text-xs text-[#2148C0] font-medium mt-1">
                                                    🔥Coming soon
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Other Tools */}
                        <div>

                            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-4 gap-6">
                                {quickActions.slice(4).map((action) => (
                                    <div
                                        key={action.id}
                                        onClick={() => handleNavigate(action.path, action.comingSoon, action.requiresSubscription)}
                                        className="group relative bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer transform hover:-translate-y-2 border border-gray-100 overflow-hidden"
                                    >
                                        {/* Hover overlay */}
                                        <div
                                            className={`absolute inset-0 bg-gradient-to-r ${action.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}
                                        ></div>

                                        <div className="relative z-10 flex flex-col items-center text-center space-y-3">
                                            <div className="text-4xl group-hover:scale-110 transition-transform duration-300">
                                                {action.icon}
                                            </div>
                                            <h4 className="font-semibold text-gray-800 group-hover:text-[#2148C0] transition-colors duration-200">
                                                {action.title}
                                            </h4>
                                            <p className="text-sm text-gray-600 group-hover:text-gray-700 transition-colors duration-200 leading-snug">
                                                {action.description}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                </div>


                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    {/* Subjects Section */}
                    <div className="lg:col-span-2">
                        {userSubjects.length > 0 && (
                            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
                                <div className="flex items-center justify-between mb-6">
                                    <h3 className="text-xl font-bold text-gray-800 flex items-center">
                                        <BookOpen className="mr-3 w-6 h-6 text-[#2148C0]" />
                                        My Subjects
                                        <span className="ml-3 bg-gradient-to-r from-[#2148C0] to-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                                            {userSubjects.length}
                                        </span>
                                    </h3>
                                </div>

                                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                    {[...displayedSubjects] // make a copy so original isn't mutated
                                        .sort((a, b) => a.localeCompare(b)) // alphabetical sort
                                        .map((subject, index) => (
                                            <div
                                                key={index}
                                                className="group bg-gradient-to-br from-gray-50 to-white p-4 rounded-xl border border-gray-100 hover:shadow-lg hover:border-[#2148C0] transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
                                                onClick={() => handleNavigate(`/take-exam-free?subject=${encodeURIComponent(subject)}`)}
                                            >
                                                <div className="text-center">
                                                    <div className="mb-3 flex justify-center group-hover:scale-110 transition-transform duration-300">
                                                        {getSubjectIcon(subject)}
                                                    </div>
                                                    <p className="text-sm font-semibold text-gray-700 group-hover:text-[#2148C0] transition-colors duration-200 leading-tight">
                                                        {subject}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                </div>


                                {userSubjects.length > 6 && (
                                    <div className="text-center mt-6">
                                        <button
                                            onClick={() => setShowAllSubjects(!showAllSubjects)}
                                            className="inline-flex items-center text-sm text-[#2148C0] hover:text-blue-700 font-medium transition-colors duration-200 bg-blue-50 px-4 py-2 rounded-lg hover:bg-blue-100"
                                        >
                                            {showAllSubjects ? (
                                                <>
                                                    <ChevronUp className="mr-2 w-4 h-4" />
                                                    Show Less
                                                </>
                                            ) : (
                                                <>
                                                    <ChevronDown className="mr-2 w-4 h-4" />
                                                    Show More ({userSubjects.length - 6} more)
                                                </>
                                            )}
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                </div>
            </main>

            {/* Footer */}
            <footer className="mt-16 bg-gradient-to-r from-gray-900 to-gray-800 text-white py-8">
                <div className="container mx-auto px-4">
                    <div className="text-center">
                        <div className="flex items-center justify-center mb-4">
                            <FaGraduationCap className="text-2xl mr-2" />
                            <span className="text-xl font-bold">TeeChaa</span>
                        </div>
                        <p className="text-gray-400 text-sm">
                            &copy; {new Date().getFullYear()} TeeChaa CBT Application. Empowering students to achieve excellence.
                        </p>
                        <div className="mt-4 flex items-center justify-center space-x-6 text-sm text-gray-400">
                            <span>Made with ❤️ for students</span>
                            <span>•</span>
                            <span>AI-Powered Learning</span>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
};

export default FreeDashboard;